import { Fieldset } from "@circle-react-uikit/Fieldset";
import { Radio as UikitRadio } from "@circle-react-uikit/Radio";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Radio, RadioGroup } from "@headlessui/react-v2";
import type { ReactNode } from "react";
import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";

import type { Option } from "../types";

interface RenderOptionProps extends Option {
  name: string;
}

export interface RadioGroupRadioProps {
  disabled?: boolean;
  itemLabelClassName?: string;
  name: string;
  options: Option[];
  renderOption?: (props: RenderOptionProps) => ReactNode;
  rules?: RegisterOptions;
  verticalSpacing?: string;
}

export const RadioGroupRadio = ({
  name,
  rules = {},
  options,
  verticalSpacing = "tight",
  renderOption,
  disabled = false,
  itemLabelClassName = "",
}: RadioGroupRadioProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <RadioGroup
          value={value}
          onChange={onChange}
          as={Fieldset}
          verticalSpacing={verticalSpacing}
        >
          {options.map(({ label, value, description }) =>
            renderOption ? (
              renderOption({ name, label, value, description })
            ) : (
              <Radio
                key={value}
                value={value}
                as="div"
                disabled={disabled}
                className={classNames({
                  "pointer-events-none": disabled,
                })}
              >
                {({ checked }) => (
                  <UikitRadio
                    id={`${name}-radio-${value}`}
                    label={label}
                    description={description}
                    checked={checked}
                    labelClassName={itemLabelClassName}
                  />
                )}
              </Radio>
            ),
          )}
        </RadioGroup>
      )}
    />
  );
};
